// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","809":"component---src-pages-index-mdx"}[chunkId] + "-" + {"218":"a8a535716329eadc9ed7","809":"fc44cfd100cb58414d59"}[chunkId] + ".js";
};